import { render, staticRenderFns } from "./CurrentPermitLicenses.vue?vue&type=template&id=5130b8a8&"
import script from "./CurrentPermitLicenses.vue?vue&type=script&lang=js&"
export * from "./CurrentPermitLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5130b8a8')) {
      api.createRecord('5130b8a8', component.options)
    } else {
      api.reload('5130b8a8', component.options)
    }
    module.hot.accept("./CurrentPermitLicenses.vue?vue&type=template&id=5130b8a8&", function () {
      api.rerender('5130b8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/dashboard/CurrentPermitLicenses.vue"
export default component.exports